__turbopack_context__.v({
  "checkIcon": "LanguageSelectorPill-module__j_Qftq__checkIcon",
  "chevron": "LanguageSelectorPill-module__j_Qftq__chevron",
  "chevronOpen": "LanguageSelectorPill-module__j_Qftq__chevronOpen",
  "container": "LanguageSelectorPill-module__j_Qftq__container",
  "dropdownPopover": "LanguageSelectorPill-module__j_Qftq__dropdownPopover",
  "flagBadge": "LanguageSelectorPill-module__j_Qftq__flagBadge",
  "isOpen": "LanguageSelectorPill-module__j_Qftq__isOpen",
  "isSelected": "LanguageSelectorPill-module__j_Qftq__isSelected",
  "label": "LanguageSelectorPill-module__j_Qftq__label",
  "optionContent": "LanguageSelectorPill-module__j_Qftq__optionContent",
  "optionItem": "LanguageSelectorPill-module__j_Qftq__optionItem",
  "pillButton": "LanguageSelectorPill-module__j_Qftq__pillButton",
});
